import { Text, VFlow } from 'bold-ui'
import React from 'react'

import { NewsHeadingSection } from './NewsHeadingSection'

export function NewsInternalEstabilizacaoV42() {
  return (
    <VFlow>
      <NewsHeadingSection title='Versão 4.2.9' subtitle=' | 24/09/2021'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Inclusão de novas CID10: "U099 - CONDIÇÃO DE SAÚDE POSTERIOR À COVID-19, NÃO ESPECIFICADA", "U109 - SÍNDROME
            INFLAMATÓRIA MULTISSISTÊMICA ASSOCIADA À COVID-19, NÃO ESPECIFICADA" e "U07.2 - COVID-19, VÍRUS NÃO
            IDENTIFICADO".
          </Text>
          <Text component='li'>
            Inclusão da dose adicional e da dose de reforço para os imunobiológicos de Covid-19 das fabricantes Pfizer,
            Astrazeneca e Janssen.
          </Text>
          <Text component='li'>Atualização da tabela INEP conforme censo de 2020.</Text>
          <Text component='li'>Atualização do grupo de atendimentos para vacinação de campanha.</Text>
          <Text component='li'>
            Envio dos campos peso e altura dos atendimentos de procedimentos e atendimentos odontológicos para o
            Centralizador Nacional.
          </Text>
          <Text component='li'>
            Correção de cenário em que o bloco de registro anterior era apresentado no histórico da ficha de atendimento
            odontológico.
          </Text>
          <Text component='li'>
            Correção de erro onde algumas fichas de vinculação da equipe do cidadão não estavam sendo processadas.
          </Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.2.8' subtitle=' | 06/08/2021'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Correção de erro que impedia a visualização de prontuários antigos de alguns cidadãos.
          </Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.2.7' subtitle=' | 23/07/2021'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Correção de erro onde não estava sendo possível redefinir a senha do instalador atual.
          </Text>
          <Text component='li'>Inclusão de contraindicação do imunobiológico Covid-19 da Janssen para gestantes.</Text>
          <Text component='li'>
            Ajuste de cenário em que a data da última visita era enviada incorretamente para o aplicativo e-SUS
            Território.
          </Text>
          <Text component='li'>
            Correção de erro na vinculação de equipe de cidadãos com mais de uma ficha de Cadastro Individual.
          </Text>
          <Text component='li'>Ajustes de performance no módulo de Relatórios e nas Impressões.</Text>
          <Text component='li'>
            Correção de erro no histórico clínico do cidadão em que atendimentos de vacinação estavam sendo exibidos
            incorretamente em alguns casos.
          </Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.2.6' subtitle=' | 28/06/2021'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Correção de cenário onde ao cadastrar dois imunobiológicos nos Registros Anteriores de Vacinação, as
            informações não estavam sendo corretamente apresentadas no histórico.
          </Text>
          <Text component='li'>
            Atualização da lista de opções do campo Povo ou Comunidade Tradicional nas fichas de Cadastro Individual.
          </Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.2.5' subtitle=' | 17/06/2021'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Alteração no comportamento do filtro "Ver somente os atendimentos não finalizados" que não será mantido
            marcado quando os usuários saírem da tela.
          </Text>
          <Text component='li'>
            Correção de erro onde alguns municípios não estavam conseguindo fazer a importação do arquivo CNES.
          </Text>
          <Text component='li'>Otimizações na comunicação cliente-servidor.</Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.2.4' subtitle=' | 02/06/2021'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>Correção de erro ao tentar realizar login no sistema.</Text>
        </VFlow>
      </NewsHeadingSection>
    </VFlow>
  )
}
